import { Link } from "react-router-dom";
import { Heart, GitCompareArrows, Share2, Flag } from "lucide-react";
import { toast } from "sonner";
import { useCompare, useWishlist } from "@/lib/collections";

export function HeartButton({ carId, className = "" }) {
  const w = useWishlist();
  const on = w.has(carId);
  return (
    <button type="button" aria-label={on ? "Remove from wishlist" : "Save to wishlist"} aria-pressed={on} data-testid={`wishlist-toggle-${carId}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); w.toggle(carId); }}
      className={`grid h-9 w-9 place-items-center rounded-full bg-white/95 shadow-sm ring-1 ring-hc-sage transition-transform duration-200 hover:scale-110 ${className}`}>
      <Heart className={`h-4 w-4 transition-colors duration-200 ${on ? "fill-hc-error text-hc-error" : "text-hc-ink"}`} />
    </button>
  );
}

export function CompareButton({ carId, small }) {
  const c = useCompare();
  const on = c.has(carId);
  return (
    <button type="button" data-testid={`compare-toggle-${carId}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); c.toggle(carId); }}
      className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold transition-colors duration-200 ${on ? "border-hc-green bg-hc-green text-white" : "border-hc-sage bg-white text-hc-ink hover:border-hc-green hover:text-hc-green"}`}>
      <GitCompareArrows className="h-3.5 w-3.5" />{on ? "Comparing" : small ? "Compare" : "Add to compare"}
    </button>
  );
}

export function CarActions({ car }) {
  const share = async () => {
    const url = `${window.location.origin}/cars/${car.id}`;
    try {
      if (navigator.share) await navigator.share({ title: `${car.name} on HooreCars`, url });
      else {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't share — copy the link from the address bar");
    }
  };
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="car-actions">
      <HeartButton carId={car.id} />
      <CompareButton carId={car.id} />
      <button type="button" onClick={share} data-testid="car-share-btn" className="inline-flex items-center gap-1.5 rounded-lg border border-hc-sage bg-white px-2.5 py-1 text-xs font-semibold text-hc-ink transition-colors duration-200 hover:border-hc-green hover:text-hc-green">
        <Share2 className="h-3.5 w-3.5" />Share
      </button>
      <Link to={`/support?car=${car.id}`} data-testid="car-report-link" className="inline-flex items-center gap-1.5 px-2 py-1 text-xs text-hc-slate hover:text-hc-error">
        <Flag className="h-3.5 w-3.5" />Report listing
      </Link>
    </div>
  );
}
